<template>
  <div>
    <div id="uniquemodal" ref="instance" class="modal fade show" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" :style="widthStyle">
        <div class="modal-content">
          <div :class="{ 'p-0': fullHeader }" class="modal-header" style="border:0">
            <slot name="header" />
          </div>
          <div class="modal-body" :style="bodyStyle">
            <slot name="body" />
          </div>
          <div
            v-if="!hideFooter"
            class="modal-footer flex-wrap justify-content-center position-relative"
          >
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { $$ } from "./../sharedscripts/OO_jquery";
export default {
  computed: {
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },
    bodyStyle() {
      return [];
    },
    widthStyle() {
      return [{ "max-width": this.width }];
    }
  },
  props: {
    fullHeader: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "500px"
    },
    hideFooter: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$nextTick(() => {
      let that = this;
      const bodyScrollLock = require("body-scroll-lock");
      var targetElement = $$(".pitem-details");
      $(this.$refs.instance).modal("show");
      $(this.$refs.instance).on("hidden.bs.modal", function() {
        that.$emit("close");
        if (that.isIos || that.isWC()) {
          for (var i = 0; i < targetElement.length; i++) {
            bodyScrollLock.enableBodyScroll(targetElement[i]);
          }
          bodyScrollLock.clearAllBodyScrollLocks();
        }
        //
      });
      $(this.$refs.instance).on("shown.bs.modal", function() {
        that.$emit("open");
        if (that.isIos || that.isWC()) {
          targetElement = $$(".pitem-details");
          for (var i = 0; i < targetElement.length; i++) {
            bodyScrollLock.disableBodyScroll(targetElement[i]);
          }
        }
        //
      });
    });
  },
  methods: {
    hideModal() {
      $(this.$refs.instance).modal("hide");
    }
  }
};
</script>
